/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyMonitoredObjectGroupSharing
 */
export interface ReadOnlyMonitoredObjectGroupSharing {
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectGroupSharing
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectGroupSharing
     */
    readonly deleted?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectGroupSharing
     */
    monitoredObjectGroup: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectGroupSharing
     */
    receiver: number;
}

export function ReadOnlyMonitoredObjectGroupSharingFromJSON(json: any): ReadOnlyMonitoredObjectGroupSharing {
    return ReadOnlyMonitoredObjectGroupSharingFromJSONTyped(json, false);
}

export function ReadOnlyMonitoredObjectGroupSharingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMonitoredObjectGroupSharing {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'monitoredObjectGroup': json['monitored_object_group'],
        'receiver': json['receiver'],
    };
}

export function ReadOnlyMonitoredObjectGroupSharingToJSON(value?: ReadOnlyMonitoredObjectGroupSharing | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'monitored_object_group': value.monitoredObjectGroup,
        'receiver': value.receiver,
    };
}


